
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-booking",
      function () {
        return require("private-next-pages/my-booking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-booking"])
      });
    }
  